import { IReparceling } from 'modules/customer/domain/entities';
import {
  PAYMENT_METHOD_TO_DOMAIN,
  TVectisPaymentMethodType,
} from 'shared/infra/adapters';

export interface IVectisReparceling {
  hash: string;
  valido: boolean;
  idCliente: number;
  nomeCliente: string;
  codigoContrato: number;
  idContrato: number;
  descricaoItensContrato: string[];
  percentualMinimoEntrada: number;
  valorMinimoEntrada: number;
  valorPendente: number;
  valorFuturo: number;
  valorTotalReparcelamento: number;
  formasPagamentoDisponivel: TVectisPaymentMethodType[];
  parcelas: Array<{
    numeroParcela: number;
    valor: number;
    valorFinal: number;
    valorMulta: number;
    data: string;
  }>;
}

export class Reparceling implements IReparceling {
  public hash: IReparceling['hash'];
  public valid: IReparceling['valid'];
  public customer: IReparceling['customer'];
  public contract: IReparceling['contract'];
  public cashMinimum: IReparceling['cashMinimum'];
  public installments: IReparceling['installments'];
  public paymentMethods: IReparceling['paymentMethods'];

  constructor({
    hash,
    valido,
    idCliente,
    nomeCliente,
    codigoContrato,
    idContrato,
    descricaoItensContrato,
    percentualMinimoEntrada,
    valorMinimoEntrada,
    valorFuturo,
    valorPendente,
    valorTotalReparcelamento,
    formasPagamentoDisponivel,
    parcelas,
  }: IVectisReparceling) {
    this.hash = hash;
    this.valid = valido;
    this.customer = {
      id: idCliente,
      name: nomeCliente,
    };
    this.contract = {
      code: codigoContrato,
      id: idContrato,
      areas: descricaoItensContrato,
    };
    this.cashMinimum = {
      calculationPercentage: percentualMinimoEntrada,
      value: valorMinimoEntrada,
    };
    this.installments = {
      total: valorTotalReparcelamento,
      next: valorFuturo,
      pending: valorPendente,
      list: parcelas.map(installment => ({
        date: installment.data,
        fine: { value: installment.valorMulta },
        number: installment.numeroParcela,
        value: {
          initial: installment.valor,
          withInterest: installment.valorFinal,
        },
        hasFineOrInterest: installment.valor !== installment.valorFinal,
      })),
    };
    this.paymentMethods = formasPagamentoDisponivel
      .filter(method => method in PAYMENT_METHOD_TO_DOMAIN)
      .map(method => PAYMENT_METHOD_TO_DOMAIN[method]);
  }
}
